export default __webpack_public_path__ + "static/media/tdr.fd75c125.png";